import { INavigationItem } from 'shared-interfaces'
import tech_info_icon_blue from '@/public/assets/icons/tech_info_icon_blue.svg'
import car_overview_icon_blue from '@/public/assets/icons/car_overview_icon_blue.svg'
import gallery_icon_blue from '@/public/assets/icons/gallery_icon_blue.svg'
import history_file_blue from '@/public/assets/icons/history_file_blue.svg'
import history_file_black from '@/public/assets/icons/history_file_black.svg'
import garage_black from '@/public/assets/icons/garage_black.svg'
import tasks_black from '@/public/assets/icons/tasks_black.svg'
import logo_no_text from '@/public/assets/logo/logo_no_text.svg'

export const page_navigation_data = (
    carid: any,
    garage_id?: any
): INavigationItem[] => {
    return [
        {
            id: 'overview',
            pageName: 'overview',
            url: garage_id
                ? `/garage/${garage_id}/car/${carid}/overview`
                : `/car/${carid}/overview`,
            icon: car_overview_icon_blue,
        },
        {
            id: 'gallery',
            pageName: 'gallery',
            url: garage_id
                ? `/garage/${garage_id}/car/${carid}/gallery`
                : `/car/${carid}/gallery`,
            icon: gallery_icon_blue,
        },
        {
            id: 'technical_information',
            pageName: 'technical information',
            url: garage_id
                ? `/garage/${garage_id}/car/${carid}/technical-information`
                : `/car/${carid}/technical-information`,
            icon: tech_info_icon_blue,
        },
        {
            id: 'history_file',
            pageName: 'history file',
            url: garage_id
                ? `/garage/${garage_id}/car/${carid}/history-file`
                : `/car/${carid}/history-file`,
            icon: history_file_blue,
            disabled: true,
        },
    ]
}

export const platformMenunData: INavigationItem[] = [
    {
        id: 'garage',
        pageName: 'your garage',
        url: `https://app.custodian.club/garage`,
        icon: garage_black,
    },
    {
        id: 'history_file',
        pageName: 'your history file',
        url: `https://app.custodian.club/history-files`,
        icon: history_file_black,
        disabled: true,
    },
    {
        id: 'tasks',
        pageName: 'your tasks',
        url: `https://app.custodian.club/tasks`,
        icon: tasks_black,
    },
    {
        id: 'about_us',
        pageName: 'about us',
        url: `https://www.custodian.club`,
        icon: logo_no_text,
    },
]
